import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const TOY_CATALOG_CHANGED = "toy-catalog-changed";
export function refreshToySuggestions() {
  window.dispatchEvent(new Event(TOY_CATALOG_CHANGED));
}

export default function useToySuggestions(audience = "staff") {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const refresh = () => setAttempt((n) => n + 1);
    // Refresh other sessions too, without touching selected form values.
    const timer = window.setInterval(refresh, 60000);
    window.addEventListener("focus", refresh);
    window.addEventListener(TOY_CATALOG_CHANGED, refresh);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", refresh);
      window.removeEventListener(TOY_CATALOG_CHANGED, refresh);
    };
  }, []);
  useEffect(() => {
    const controller = new AbortController();
    let live = true;
    setLoading(true);
    setError(false);
    const path = audience === "client" ? "/portal/sharing-tree/toy-suggestions" : "/sharing-tree/toy-suggestions";
    api.get(path, { signal: controller.signal })
      .then(({ data }) => {
        if (!live) return;
        if (!Array.isArray(data?.items)) throw new Error("Invalid suggestions");
        setItems(data.items);
      })
      .catch(() => { if (live) setError(true); })
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; controller.abort(); };
  }, [audience, attempt]);
  return { items, loading, error, retry: () => setAttempt((n) => n + 1) };
}
